import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatsCardProps {
  icon: LucideIcon;
  label: string;
  value: number;
  iconBg?: string;
  onClick?: () => void;
}

export default function StatsCard({ icon: Icon, label, value, iconBg = "bg-primary/10", onClick }: StatsCardProps) {
  return (
    <Card 
      className={`p-4 ${onClick ? 'cursor-pointer hover-elevate' : ''}`}
      onClick={onClick}
      data-testid={`card-stat-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{label}</p>
          <p className="text-2xl font-bold" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            {value}
          </p>
        </div>
        <div className={`${iconBg} p-2 rounded-lg`}>
          <Icon className="w-5 h-5 text-primary" />
        </div>
      </div>
    </Card>
  );
}
